import React from 'react';
import { format, isBefore } from 'date-fns';
import user_logo from 'assets/icons/user.svg';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { DeviceTableProps } from './DeviceField';
import { useTranslation } from 'react-i18next';

const DeviceTable: React.FC<DeviceTableProps> = ({
  devices,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation('device');
  const getColorClass = (status: string) => {
    let stylesSnippet = 'flex items-center justify-center rounded w-24 h-7  ';
    if (status === 'available') {
      return stylesSnippet + 'bg-primary/50 text-success';
    } else if (status === 'in_repair') {
      return stylesSnippet + 'bg-[#FFF8E7] text-warning';
    } else if (status === 'damaged') {
      return stylesSnippet + 'bg-[#FFE5EE] text-error';
    }
  };

  const checkDate = (initialDate: any) => {
    let newDate =
      format(new Date(initialDate), 'yyyy-MM-dd') === '1970-01-01'
        ? '-'
        : format(new Date(initialDate), t('table.date-format'));
    return newDate;
  };

  return (
    <main className="flex flex-col my-6">
      <div className="grid grid-cols-9 gap-4 px-2 py-2.5 bg-primary/50 rounded-md w-full">
        <div className="col-span-1 ">{t('table.device-id')}</div>
        <div className="col-span-2 ">{t('table.device-name')}</div>
        <div className="col-span-2 ">{t('table.status')}</div>
        <div className="col-span-1  text-center">
          {t('table.assigned-date')}
        </div>
        <div className="col-span-1  text-center">{t('table.purchase')}</div>
        <div className="col-span-1  text-center"> {t('table.warranty')}</div>
        <div className="col-span-1  text-center"> {t('table.action')}</div>
      </div>
      {devices.length === 0 ? (
        <div className="text-center my-4">{t('table.no-data')}</div>
      ) : (
        devices.map((device, index) => (
          <div
            key={index}
            className="grid grid-cols-9 gap-3 px-2 sm:h-8 md:h-12 lg:h-16 border-b"
          >
            <div className="col-span-1 flex items-center  text-neutral/100">
              {device.device_id}
            </div>
            <div className="col-span-2 flex items-center  truncate">
              {device.name}
            </div>
            {device.status === 'using' ? (
              <div className="col-span-2 flex space-x-2 items-center truncate">
                {
                  <img
                    src={device.user_info?.profile_picture || user_logo}
                    alt="User"
                    className="h-10 w-10 object-cover rounded-full"
                  />
                }
                <div>
                  <div className="text-caption">
                    {device.user_info?.name || t('table.no-data')}
                  </div>
                  <div className=" text-neutral/100 text-overline w-32">
                    {device.user_info?.phone || device.user_info?.email || ''}
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-span-2 flex items-center">
                <div className={getColorClass(device.status)}>
                  {t(`status.${device.status}`)}
                </div>
              </div>
            )}
            <div className="col-span-1 flex items-center justify-center  text-center">
              {format(new Date(device.update_time), t('table.date-format')) ||
                format(new Date(device.assigned_date), t('table.date-format'))}
            </div>
            <div className="col-span-1 flex items-center justify-center  text-center">
              {checkDate(device.purchase_date)}
            </div>
            <div
              className={`col-span-1 flex items-center justify-center  text-center ${
                isBefore(device.warranty_date, new Date())
                  ? 'text-error'
                  : 'text-neutral/300'
              }`}
            >
              {checkDate(device.warranty_date)}
            </div>
            <div className="col-span-1 flex items-center justify-center gap-3 text-neutral/100 cursor-pointer">
              <IconEdit
                size={20}
                stroke={1.5}
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(device.id);
                }}
              />
              <IconTrash
                size={20}
                stroke={1.5}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(device.id);
                }}
              />
            </div>
          </div>
        ))
      )}
    </main>
  );
};
export default DeviceTable;
